import api from "lib/api";

export const getHospital = async (params = {}) => {
    return await api.post("/v1/dropdown/getHospital", params);
};

export const getNationality = async (params = {}) => {
    return await api.post("/v1/dropdown/getNationality", params);
};

export const getSocialSecurity = async (params = {}) => {
    return await api.post("/v1/employee/getSocialSecurity", params);
};

export const getRegistrationDocument = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};

export const getReasonForSsoDocument = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};

export const updateSocialSecurity = async (params = {}) => {
    return await api.post("/v1/employee/updateSocialSecurity", params);
};

export const getRelationship = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};